import { SVGProps } from 'react';
const SearchQuestionIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={48}
        height={48}
        viewBox="0 0 48 48"
    >
        <path
            stroke="#001965"
            strokeWidth={2}
            d="m28.405 27.023-.615.704.661.662 15.447 15.447a.5.5 0 0 1 0 .707.494.494 0 0 1-.353.147.493.493 0 0 1-.354-.147l-15.51-15.51-.623-.624-.697.54A14.405 14.405 0 0 1 17.5 32C9.505 32 3 25.495 3 17.5S9.505 3 17.5 3 32 9.505 32 17.5c0 3.644-1.361 6.97-3.595 9.523ZM17.5 4C10.055 4 4 10.055 4 17.5S10.055 31 17.5 31 31 24.945 31 17.5 24.945 4 17.5 4Z"
        />
        <path
            fill="#001965"
            d="M21.5 13.271c0-1.938-1.573-3.271-3.96-3.271-2.547 0-4 1.454-4.04 3.54h2.253c.054-.928.68-1.52 1.64-1.52.96 0 1.587.551 1.587 1.332 0 .78-.32 1.184-1.4 1.83-1.147.687-1.6 1.441-1.48 2.787v.458h2.2v-.444c0-.808.307-1.225 1.413-1.872 1.174-.7 1.787-1.575 1.787-2.84ZM18.82 22.385c0-.889-.72-1.616-1.6-1.616-.88 0-1.6.727-1.6 1.616 0 .888.72 1.615 1.6 1.615.88 0 1.6-.727 1.6-1.615Z"
        />
    </svg>
);
export default SearchQuestionIcon;
